import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
    mapCardBrand,
    stripNonAlphanumericChars,
} from '../../../helpers/helper-functions';
import {
    PaymethodFormValidator,
    validateCardNumber,
} from '../../../helpers/validators';

import * as braintree from 'braintree-web';
import * as braintreeDataCollector from 'braintree-web/data-collector';
import { Select } from '@ngxs/store';
import { ModulesSelectors } from '@serviceos-ng/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'serviceos-web-braintree',
    templateUrl: './braintree.component.html',
    styleUrls: ['./braintree.component.scss'],
})
export class BraintreeComponent implements OnInit {
    @Input()
    public paymethodSetup: any;

    public cardDetails: FormGroup;
    private client;
    public saveCard = false;
    public formSubmit = false;
    public unsupportedBrands: Array<string> = [];
    private unsupportedBrandUsed = false;

    private braintree;
    private braintreeDataCollector;

    @Select(ModulesSelectors.getComponentFromModule('customer', 'payments'))
    paymentsConfig$!: Observable<any>

    public paymentsConfig: any = null;

    constructor(private _formBuilder: FormBuilder) {
        this.paymentsConfig$.subscribe((config) => {
            if (config) {
                this.paymentsConfig = config;
            }
        });

        this.cardDetails = this._formBuilder.group(
            {
                cardNumber: ['', [Validators.required]],
                expiry: ['', [Validators.required]],
                nameOnCard: ['', [Validators.required]],
                cvv: ['', [Validators.required]],
            },
            { validator: PaymethodFormValidator }
        );
    }

    get cardNumber() {
        return this.cardDetails.get('cardNumber');
    }

    get expiry() {
        return this.cardDetails.get('expiry');
    }

    get nameOnCard() {
        return this.cardDetails.get('nameOnCard');
    }

    get cvv() {
        return this.cardDetails.get('cvv');
    }

    ngOnInit(): void {
        this.initialize();
    }

    /**
     * Init component
     */
    private initialize() {
        // Get unsupported brands for this payment method
        if (this.paymethodSetup?.payload?.unsupported_brands) {
            this.unsupportedBrands = this.paymethodSetup.payload.unsupported_brands;
        }
    }

    /**
     * Check choice for the user and return the token for the payment
     */
    public getPaymentObject(typeOfCard: 'new' | 'existing'): Promise<any> {
        if (typeOfCard === 'new') this.validateForm();

        return new Promise((resolve, reject) => {
            if (this.unsupportedBrandUsed) {
                const modalData: any = {
                    message: 'paymentErrorMsg3',
                };

                return reject({
                    message:
                        'Your card is not supported. Please, try a different card brand.',
                });
            }

            // // "Paymethod is ready for checkout!" - directly resolve with paymethod data
            // if (!this.paymethodSetup || !this.paymethodSetup.type) {
            //     const paymentData = {
            //         payment_method_id: this.paymentMethod.id,
            //         paymethod: {
            //             id: this.paymethod.id,
            //         },
            //     };

            //     return resolve(paymentData);
            // }

            let publicKey: any = null;

            if (this.paymethodSetup) {
                // Get payment method public key
                if (
                    this.paymethodSetup.payload &&
                    this.paymethodSetup.payload.public_key
                ) {
                    publicKey = this.paymethodSetup.payload.public_key;
                }

                // Get unsupported brands for this payment method
                if (
                    this.paymethodSetup.payload &&
                    this.paymethodSetup.payload.unsupported_brands
                ) {
                    this.unsupportedBrands = this.paymethodSetup.payload.unsupported_brands;
                }

                const use3DSecure: boolean =
                    this.paymethodSetup.type &&
                    (this.paymethodSetup.type === 'braintree_create_3ds' ||
                        this.paymethodSetup.type === 'braintree_validate_3ds')
                        ? true
                        : false;

                if (typeOfCard === 'new') {
                    if (this.cardDetails.valid) {
                        // initial check for used unsupported card brand
                        if (
                            this.paymethodSetup.payload &&
                            this.paymethodSetup.payload.unsupported_brands
                        ) {
                            const unsupportedBrands: Array<string> = this
                                    .paymethodSetup.payload.unsupported_brands,
                                validationResult: any = validateCardNumber(
                                    this.cardNumber?.value
                                );

                            let unsupportedBrandUsed = false;

                            if (
                                validationResult.isValid &&
                                validationResult.card &&
                                validationResult.card.type
                            ) {
                                const mappedCardBrandName:
                                        | string
                                        | null = mapCardBrand(
                                        validationResult.card.type
                                    ),
                                    cardBrandName: string = mappedCardBrandName
                                        ? mappedCardBrandName
                                        : stripNonAlphanumericChars(
                                              validationResult.card.type
                                          ).toLowerCase();

                                // Set flag which will open modal for unsupported card brand
                                unsupportedBrandUsed =
                                    unsupportedBrands &&
                                    unsupportedBrands.find(
                                        (brandName: string) =>
                                            stripNonAlphanumericChars(
                                                brandName
                                            ).toLowerCase() === cardBrandName
                                    )
                                        ? true
                                        : false;
                            }

                            if (unsupportedBrandUsed) {
                                return reject({
                                    message:
                                        'Your card is not supported. Please, try a different card brand.',
                                });
                            }
                        }

                        this.createToken(use3DSecure, publicKey, typeOfCard)
                            .then(
                                (tokenData: any) => {
                                    // Success

                                    resolve(tokenData);
                                },
                                (error: any) => {
                                    // Error
                                    reject(error);
                                }
                            )
                            .catch((error) => {
                                reject(error);
                            });
                    } else {
                        reject();
                    }
                } else {
                    // if (this.paymethod) {
                    //     if (!use3DSecure) {
                    //         // this should NOT happen! setup should've returned success code 2000
                    //         const paymentData = {
                    //             payment_method_id: this.paymentMethod.id,
                    //             paymethod: {
                    //                 id: this.paymethod.id,
                    //             },
                    //         };
                    //         resolve(paymentData);
                    //     } else {
                    //         this.createToken(use3DSecure)
                    //             .then(
                    //                 (tokenData: any) => {
                    //                     // Success
                    //                     const paymentData = {
                    //                         payment_method_id: this
                    //                             .paymentMethod.id,
                    //                         paymethod: {
                    //                             id: this.paymethod.id,
                    //                             setup: {
                    //                                 type: this.paymethodSetup
                    //                                     .type,
                    //                                 payload: tokenData,
                    //                             },
                    //                         },
                    //                     };
                    //                     resolve(paymentData);
                    //                 },
                    //                 (error: any) => {
                    //                     // Error
                    //                     reject(error);
                    //                 }
                    //             )
                    //             .catch((error) => {
                    //                 reject(error);
                    //             });
                    //     }
                    // } else {
                    //     // No existing payment selected
                    //     reject('No payment selected');
                    // }
                }
            }
        });
    }

    /**
     * Create token for the new card
     * @param callback
     */
    public createToken(
        useBraintree3DS: boolean,
        publicKey: string,
        typeOfCard: 'new' | 'existing'
    ): Promise<any> {
        return new Promise((resolve: Function, reject: Function) => {
            let threeDSecure: any = null;

            // initialize braintree client
            braintree.client
                .create({
                    authorization: publicKey,
                })
                .then((clientInstance) => {
                    this.client = clientInstance;

                    // initialize braintree data collector
                    braintreeDataCollector
                        .create({
                            client: clientInstance,
                            kount: true,
                            paypal: true,
                        })
                        .then((dataCollectorInstance) => {
                            // new paymethod
                            if (typeOfCard === 'new') {
                                this.client
                                    .request({
                                        endpoint:
                                            'payment_methods/credit_cards',
                                        method: 'post',
                                        data: {
                                            creditCard: {
                                                number: this.cardNumber?.value,
                                                expirationDate: this.expiry
                                                    ?.value,
                                                cvv: this.cvv?.value,
                                                cardholderName: this.nameOnCard
                                                    ?.value,
                                            },
                                        },
                                    })
                                    .then(
                                        (response: any) => {
                                            // Success
                                            if (useBraintree3DS) {
                                                // initialize 3DS module
                                                braintree.threeDSecure
                                                    .create({
                                                        version: 2, // Will use 3DS 2 whenever possible
                                                        client: clientInstance,
                                                        cardinalSDKConfig: {
                                                            timeout: 10000,
                                                            maxRequestRetries: 3,
                                                        },
                                                    })
                                                    .then(
                                                        (
                                                            threeDSecureInstance
                                                        ) => {
                                                            threeDSecure = threeDSecureInstance;

                                                            const threeDSecurePayload: {
                                                                amount: number;
                                                                nonce: string;
                                                                onLookupComplete: Function;
                                                                bin?: string;
                                                            } = {
                                                                amount: this
                                                                    .paymethodSetup
                                                                    ?.payload
                                                                    ?.amount,
                                                                nonce:
                                                                    response
                                                                        .creditCards[0]
                                                                        .nonce,
                                                                onLookupComplete: (
                                                                    data,
                                                                    next
                                                                ) => {
                                                                    next();
                                                                },
                                                            };

                                                            if (
                                                                response
                                                                    .creditCards[0]
                                                                    .details &&
                                                                response
                                                                    .creditCards[0]
                                                                    .details.bin
                                                            ) {
                                                                Object.assign(
                                                                    threeDSecurePayload,
                                                                    {
                                                                        bin:
                                                                            response
                                                                                .creditCards[0]
                                                                                .details
                                                                                .bin,
                                                                    }
                                                                );
                                                            }

                                                            threeDSecure
                                                                .verifyCard(
                                                                    threeDSecurePayload
                                                                )
                                                                .then(
                                                                    (
                                                                        threeDSresponse
                                                                    ) => {
                                                                        if (
                                                                            !threeDSresponse
                                                                                .threeDSecureInfo
                                                                                .liabilityShiftPossible
                                                                        ) {
                                                                            reject(
                                                                                {
                                                                                    message:
                                                                                        '3DS verification fail. This might be because of a wrong verification code or some issue with your bank. Please use another card or try again later.',
                                                                                }
                                                                            );
                                                                        } else {
                                                                            if (
                                                                                threeDSresponse
                                                                                    .threeDSecureInfo
                                                                                    .liabilityShifted
                                                                            ) {
                                                                                // Success

                                                                                const tokenData: {
                                                                                    token: string;
                                                                                    device_data: string;
                                                                                } = {
                                                                                    token:
                                                                                        threeDSresponse.nonce,
                                                                                    device_data:
                                                                                        dataCollectorInstance.deviceData,
                                                                                };

                                                                                resolve(
                                                                                    tokenData
                                                                                );
                                                                            } else {
                                                                                reject(
                                                                                    {
                                                                                        message:
                                                                                            '3DS verification fail. This might be because of a wrong verification code or some issue with your bank. Please use another card or try again later.',
                                                                                    }
                                                                                );
                                                                            }
                                                                        }
                                                                        // Handle response
                                                                    }
                                                                )
                                                                .catch(
                                                                    (error) => {
                                                                        reject({
                                                                            message:
                                                                                error.message,
                                                                        });
                                                                    }
                                                                );
                                                        }
                                                    );
                                            } else {
                                                const tokenData: {
                                                    token: string;
                                                    device_data: string;
                                                } = {
                                                    token:
                                                        response.creditCards[0]
                                                            .nonce,
                                                    device_data:
                                                        dataCollectorInstance.deviceData,
                                                };

                                                resolve(tokenData);
                                            }
                                        },
                                        (error: any) => {
                                            // Error
                                            const modalData: any = {
                                                message: '',
                                            };

                                            try {
                                                modalData.message =
                                                    error.details.originalError.error.message;
                                            } catch (error) {
                                                modalData.message =
                                                    'Your card was declined, please try again or use a different one';
                                            }

                                            reject(modalData);
                                        }
                                    )
                                    .catch((error) => {
                                        reject(error);
                                    });
                            } else {
                                // existing user paymethod
                                // initialize 3DS module
                                braintree.threeDSecure
                                    .create({
                                        version: 2, // Will use 3DS 2 whenever possible
                                        client: clientInstance,
                                        cardinalSDKConfig: {
                                            timeout: 10000,
                                            maxRequestRetries: 3,
                                        },
                                    })
                                    .then((threeDSecureInstance: any) => {
                                        threeDSecure = threeDSecureInstance;

                                        const amount: number = this
                                                .paymethodSetup?.payload
                                                ?.amount,
                                            nonce: string = this.paymethodSetup
                                                ?.payload?.nonce;

                                        // card_token is not provided from XRM
                                        if (!nonce) {
                                            return reject({
                                                message:
                                                    '3DS verification fail. This might be because of a wrong verification code or some issue with your bank. Please use another card or try again later.',
                                            });
                                        }

                                        const threeDSecurePayload: {
                                            amount: number;
                                            nonce: string;
                                            onLookupComplete: Function;
                                            bin?: string;
                                        } = {
                                            amount,
                                            nonce,
                                            onLookupComplete: (data, next) => {
                                                next();
                                            },
                                        };

                                        if (this.paymethodSetup?.payload?.bin) {
                                            Object.assign(threeDSecurePayload, {
                                                bin: this.paymethodSetup
                                                    ?.payload?.bin,
                                            });
                                        }

                                        threeDSecure
                                            .verifyCard(threeDSecurePayload)
                                            .then((response) => {
                                                if (
                                                    !response.threeDSecureInfo
                                                        .liabilityShiftPossible
                                                ) {
                                                    reject({
                                                        message:
                                                            '3DS verification fail. This might be because of a wrong verification code or some issue with your bank. Please use another card or try again later.',
                                                    });
                                                } else {
                                                    if (
                                                        response
                                                            .threeDSecureInfo
                                                            .liabilityShifted
                                                    ) {
                                                        // Success
                                                        const tokenData: {
                                                            token: string;
                                                            device_data: string;
                                                        } = {
                                                            token:
                                                                response.nonce,
                                                            device_data:
                                                                dataCollectorInstance.deviceData,
                                                        };

                                                        resolve(tokenData);
                                                    } else {
                                                        reject({
                                                            message:
                                                                '3DS verification fail. This might be because of a wrong verification code or some issue with your bank. Please use another card or try again later.',
                                                        });
                                                    }
                                                }

                                                // Handle response
                                            })
                                            .catch((error) => {
                                                reject({
                                                    message: error.message,
                                                });
                                            });
                                    });
                            }
                        })
                        .catch((e) => {
                            reject();
                        });
                })
                .catch((e) => {
                    reject();
                });
        });
    }

    /**
     * Check if payment form is valid
     */
    private validateForm(): void {
        const formControlsNames: Array<string> = Object.keys(
            this.cardDetails.controls
        );

        // Manually trigger reactive form validation
        for (
            let formControlNameIndex = 0;
            formControlNameIndex < formControlsNames.length;
            formControlNameIndex++
        ) {
            const formControlName: string =
                formControlsNames[formControlNameIndex];

            this.cardDetails.controls[formControlName].markAsTouched();
            this.cardDetails.controls[formControlName].markAsDirty();
        }

        if (!this.cardDetails.valid) {
            // Error messsage!
        }

        this.formSubmit = true;
    }
}
